<div class="search-users-dialog">
  <app-search size="m" (searchQueryChange)="onChangeSearchQuery($event)" [autofocus]="!isMobilePlatform"></app-search>

  <search-users-filters (filtersChange)="onFiltersChange($event)"></search-users-filters>

  <ng-container *ngIf="items$ | async as items">
    <div class="search-users-dialog__title">
      <span>
        {{ loading ? ('components.searchUsers.labels.loading' | translate) : title }}
      </span>

      <select-all-link
        *ngIf="mode === 'multiple' && items.length > 0 && !loading"
        [mode]="addOrRemoveItemsMode"
        (clickChange)="onAddOrRemoveItemsToResult()"
      ></select-all-link>
    </div>
  </ng-container>

  <tui-loader
    *ngIf="loading"
    class="search-users-dialog__loading"
    [size]="'l'"
    [showLoader]="true"
    [inheritColor]="true"
    [overlay]="true"
  ></tui-loader>

  <ng-container *ngIf="!loading">
    <ng-container *ngIf="items$ | async as items">
      <div *ngIf="!items.length" class="search-users-dialog__no-data">
        <span>
          {{ noDataMessage }}
        </span>
      </div>

      <tui-scrollbar *ngIf="!!items.length" class="search-users-dialog__wrapper">
        <div class="search-users-dialog__wrapper_list">
          <div *ngFor="let item of items">
            <button class="search-users-dialog__wrapper_item" type="button" [id]="item.id" (click)="onToggleItem(item)">
              <render-user-row [user]="item" [statusContent]="statusContent"></render-user-row>

              <input *ngIf="mode === 'multiple'" tuiCheckbox type="checkbox" [size]="'m'" [checked]="isChecked(item)" />

              <tui-icon *ngIf="mode === 'single' && isChecked(item)" [icon]="'@tui.check'"></tui-icon>
            </button>

            <div class="search-users-dialog__wrapper_divider"></div>
          </div>
        </div>
      </tui-scrollbar>
    </ng-container>
  </ng-container>

  <div class="search-users-dialog__footer">
    <ng-container *ngIf="result$ | async as items">
      <ng-container *ngIf="items.length > 0">
        <div class="search-users-dialog__result-count">
          {{ resultTitle }}
        </div>

        <users-tag
          class="search-users-dialog__result-tags"
          [items]="items"
          (removeItem)="onRemoveItem($event)"
          (removeAllItems)="onRemoveAllItems()"
        ></users-tag>
      </ng-container>
    </ng-container>

    <button
      tuiButton
      class="search-users-dialog__action"
      type="button"
      [size]="'m'"
      [disabled]="!(result$ | async)?.length"
      (click)="onSave()"
    >
      {{ saveButtonText }}
    </button>
  </div>
</div>
